/**
 * A 16:9 picture that falls back to the cherry on cream when there is no picture or it won't load
 * (an audio upload, posters still being made, or a file that's gone).
 */
import React, { useState } from "react";
import cherryLogo from "../../../../assets/brand/logo_site_onlight.svg";

interface Props {
  src?: string | null;
  /** No picture? Show a frame from the video itself instead of the cherry. */
  videoUrl?: string | null;
  children?: React.ReactNode;
  onClick?: (e: React.MouseEvent) => void;
  className?: string;
}

const Pic: React.FC<Props> = ({ src, videoUrl, children, onClick, className }) => {
  const [broken, setBroken] = useState(false);
  const [videoBroken, setVideoBroken] = useState(false);
  return (
    <div className={`pic${className ? ` ${className}` : ""}`} onClick={onClick}>
      {src && !broken ? (
        <img className="th" src={src} alt="" loading="lazy" onError={() => setBroken(true)} />
      ) : videoUrl && !videoBroken ? (
        // "#t=2": the browser shows the frame at 2 s (the very first frame is often black).
        <video className="th" src={`${videoUrl}#t=2`} muted playsInline preload="metadata"
          onError={() => setVideoBroken(true)}
          // An audio upload (the Premiere panel sends a mixdown) has no picture: back to the cherry.
          onLoadedMetadata={(e) => { if (!e.currentTarget.videoWidth) setVideoBroken(true); }}
        />
      ) : (
        <div className="empty"><img src={cherryLogo} alt="" /></div>
      )}
      {children}
    </div>
  );
};

export default Pic;
